import React from 'react';
import './file.css';
import { imagesShort, imagesLong } from './images';

const PDFViewer = ({ version }) => {
  const imagesToDisplay = version === 'short' ? imagesShort : imagesLong;

  return (
    <div className="pdf-container">
      {imagesToDisplay.map((image, index) => (
        <img src={image} key={index} />
      ))}
    </div>
  );
};

export default PDFViewer;



// WEBPACK FOOTER //
// ./src/components/PitchDeck/PDFViewer.js